import React, { useState, useRef, useEffect } from 'react';
import './Tooltip.css';

function Tooltip({ children, content }) {
  const [isVisible, setIsVisible] = useState(false);
  const [canHide, setCanHide] = useState(false);
  const showTimeoutRef = useRef(null);

  const handleMouseEnter = () => {
    setIsVisible(true);
    setCanHide(false);

    // Минимум 2 секунды показа
    if (showTimeoutRef.current) {
      clearTimeout(showTimeoutRef.current);
    }
    showTimeoutRef.current = setTimeout(() => {
      setCanHide(true);
    }, 2000);
  };

  const handleMouseLeave = () => {
    if (canHide) {
      setIsVisible(false);
      if (showTimeoutRef.current) {
        clearTimeout(showTimeoutRef.current);
      }
    }
  };

  const handleClose = () => {
    setIsVisible(false);
    setCanHide(true);
    if (showTimeoutRef.current) {
      clearTimeout(showTimeoutRef.current);
    }
  };

  useEffect(() => {
    return () => {
      if (showTimeoutRef.current) {
        clearTimeout(showTimeoutRef.current);
      }
    };
  }, []);

  return (
    <div
      className="tooltip-wrapper"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <span className="tooltip-trigger">
        {children}
      </span>
      {isVisible && (
        <div
          className="tooltip-content"
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <button
            className="tooltip-close-btn"
            onClick={handleClose}
            aria-label="Закрыть"
          >
            ×
          </button>
          {content}
        </div>
      )}
    </div>
  );
}

export default Tooltip;
